export const SETUP_DATA = 'SETUP_DATA';
export const RECORD_CLICK = 'RECORD_CLICK';
export const HANDLE_CLICK = 'HANDLE_CLICK';
